export const MeetingState_Both_OtherNoShow = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/otherNoShow.html';
    },
];
